import { CloseOutlinedIcon, WarningTwoToneIcon } from '@honestica/ui-kit/src/icons';
import colors from '@honestica/ui-kit/src/theme/colors';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './DocumentImportErrorFallback.module.less';

export const DocumentImportErrorFallback = () => {
  const { t } = useTranslation();
  const [dismissed, setDismissed] = useState(false);

  if (dismissed) return null;

  return (
    <div className={styles.container} data-testid="document-import-error-fallback">
      <WarningTwoToneIcon twoToneColor={colors.volcano[5]} className={styles.icon} />
      <span className={styles.message}>{t('documents.importStatus.errorBoundary.message')}</span>
      <CloseOutlinedIcon
        className={styles.closeIcon}
        onClick={() => setDismissed(true)}
        data-testid="document-import-error-fallback-close"
      />
    </div>
  );
};
